import { render, staticRenderFns } from "./actionmodal.vue?vue&type=template&id=63aef85e&scoped=true&"
import script from "./actionmodal.vue?vue&type=script&lang=js&"
export * from "./actionmodal.vue?vue&type=script&lang=js&"
import style0 from "./actionmodal.vue?vue&type=style&index=0&id=63aef85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aef85e",
  null
  
)

export default component.exports